module.exports = "<listado-general \r\n  [listado]=\"productos\" \r\n  [titulo]=\"'PRODUCTOS' | translate\"\r\n  [urladicional]=\"''\"\r\n  [ocultarNuevo]=\"true\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/product.list.component.html
// module id = ../../../../../src/app/private/product/product.list.component.html
// module chunks = main